export type PartnerSpotlightEntry = {
  id: string;
  file: string;
  alt: string;
  /** Optional visual scale (1 = default). >1 boosts thin wordmarks; <1 tames heavy marks. */
  logoDisplayScale?: number;
};

export function partnerSpotlightLogoSrc(file: string): string {
  const base = (process.env.PUBLIC_URL ?? "").replace(/\/$/, "");
  return `${base}/partner_logos/${file}`;
}

export const PARTNER_SPOTLIGHT_ENTRIES: PartnerSpotlightEntry[] = [
  {
    id: "american-express",
    file: "american-express.svg",
    alt: "American Express",
  },
  { id: "awardco", file: "awardco.svg", alt: "Awardco" },
  { id: "chase", file: "chase.svg", alt: "Chase" },
  { id: "crunchtime", file: "crunchtime.svg", alt: "Crunchtime" },
  { id: "daily-pay", file: "daily-pay.svg", alt: "DailyPay" },
  { id: "deel", file: "deel.webp", alt: "Deel" },
  {
    id: "employee-navigator",
    file: "employee-navigator.svg",
    alt: "Employee Navigator",
    logoDisplayScale: 1.12,
  },
  { id: "evans-national", file: "evans-national.png", alt: "Evans National" },
  {
    id: "fidelity",
    file: "fidelity.svg",
    alt: "Fidelity",
    logoDisplayScale: 0.92,
  },
  {
    id: "fourth",
    file: "fourth.svg",
    alt: "Fourth",
    logoDisplayScale: 0.93,
  },
  { id: "hcss", file: "hcss.svg", alt: "HCSS", logoDisplayScale: 1.22 },
  {
    id: "healthequity",
    file: "healthequity.svg",
    alt: "HealthEquity",
    logoDisplayScale: 1.45,
  },
  { id: "hi-bob", file: "hi-bob.svg", alt: "HiBob" },
  {
    id: "hr-acuity",
    file: "hr-acuity.svg",
    alt: "HR Acuity",
    logoDisplayScale: 1.2,
  },
  {
    id: "intuit-quickbooks",
    file: "intuit-quickbooks.svg",
    alt: "Intuit QuickBooks",
  },
  { id: "john-hancock", file: "john-hancock.svg", alt: "John Hancock" },
  { id: "lightspeed", file: "lightspeed.svg", alt: "Lightspeed" },
  { id: "multiplier", file: "multiplier.svg", alt: "Multiplier" },
  { id: "par", file: "par.svg", alt: "PAR Technology" },
  { id: "payactiv", file: "payactiv.svg", alt: "Payactiv" },
  { id: "paylocity", file: "paylocity.svg", alt: "Paylocity" },
  { id: "rave-mobile", file: "rave-mobile.svg", alt: "Rave Mobile Safety" },
  { id: "retailstack", file: "retailstack.svg", alt: "Retailstack" },
  { id: "sap-concur", file: "sap-concur.svg", alt: "SAP Concur" },
  {
    id: "secured-gp",
    file: "secured-gp.svg",
    alt: "Secured GiftPay",
  },
  { id: "toast", file: "toast.svg", alt: "Toast" },
  {
    id: "united-hc",
    file: "united-hc.svg",
    alt: "UnitedHealthcare",
  },
  { id: "vanguard", file: "vanguard.svg", alt: "Vanguard" },
  {
    id: "vector-solutions",
    file: "vector-solutions.svg",
    alt: "Vector Solutions",
  },
  { id: "voya", file: "voya.svg", alt: "Voya" },
  { id: "wex", file: "wex.svg", alt: "WEX", logoDisplayScale: 1.12 },
  { id: "workable", file: "workable.svg", alt: "Workable" },
];
